class TranslateKeyOptions {
	
	constructor(key) {
		this.key = key;
		this.args = [];
	}
	
	withCount(count) {
		this.count = count;
		return this;
	}
	
    withEscapeValue(escapeValue) {
        this.escapeValue = escapeValue;
        return this;
    }

	withArgument(argument) {
		this.args.push(argument);
	}
	
}

export {
	TranslateKeyOptions
}
